import React from "react";
import FormLabel from "../../Components/FormLabel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  clearBusinessInvitation,
  clearBusinessInvitationError,
  requestCreateBusinessInvitation,
  requestListBusiness,
  useAuthState,
  useBusinessInvitationDispatch,
  useBusinessInvitationState,
  useBusinessTransactionDispatch,
  useBusinessTransactionState,
} from "../../Context";
import { useEffect } from "react";
import { classNames } from "../../Utils";
import ReactDatePicker from "react-datepicker";
import { Button } from "../../Components/Button";
import ReactSelect from "react-select";
import { ModalConfirm } from "../../Components/ModalConfirm";
import { useNavigate } from "react-router-dom";
import { Alert } from "../../Components/Alert";
import InputSkeleton from "../../Components/InputSkeleton";

const BusinessInvitationCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showSuccessModal, setshowSuccessModal] = useState(false);

  const [selectedBusiness, setselectedBusiness] = useState();
  const [email, setemail] = useState("");
  const [expirationDate, setexpirationDate] = useState(null);
  const [businessError, setbusinessError] = useState(null);
  const [emailError, setemailError] = useState(null);
  const [submitted, setsubmitted] = useState(false);

  const businessInviteDispatch = useBusinessInvitationDispatch();
  const businessDispatch = useBusinessTransactionDispatch();

  const {
    newBusinessInvite,
    newBusinessInviteLoading,
    newBusinessInviteError,
  } = useBusinessInvitationState();
  const { businesses, loading: businessLoading } =
    useBusinessTransactionState();
  const { user } = useAuthState();

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const parsedErrorResponse = newBusinessInviteError?.response?.body
    ? JSON.parse(newBusinessInviteError.response.body)
    : null;
  const newExpirationDateError = parsedErrorResponse?.error?.expired_at;

  const today = new Date();
  const minDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 7
  );

  useEffect(() => {
    if (user.id) {
      requestListBusiness(businessDispatch, { owner: user.id });
    }
  }, [businessDispatch, user.id]);

  useEffect(() => {
    return () => {
      clearBusinessInvitationError(businessInviteDispatch);
    };
  }, [businessInviteDispatch]);

  useEffect(() => {
    if (submitted && email) {
      const isEmailValid = emailRegex.test(email);
      if (isEmailValid) {
        setErrorMessage("email", "");
      } else {
        setErrorMessage("email", "Please enter a valid email address.");
      }
    } else if (submitted && !email) {
      setErrorMessage("email", "Email is required.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, submitted]);

  useEffect(() => {
    if (submitted) {
      const isBusinessValid = Boolean(selectedBusiness?.id);
      if (isBusinessValid) {
        setErrorMessage("business", "");
      } else {
        setErrorMessage("business", "Business name is required.");
      }
    }
  }, [submitted, selectedBusiness]);

  useEffect(() => {
    if (newBusinessInvite?.id) {
      setshowSuccessModal(true);
    }
  }, [newBusinessInvite?.id]);

  const setErrorMessage = (field, message) => {
    switch (field) {
      case "email":
        setemailError(message);
        break;
      case "business":
        setbusinessError(message);
        break;
      default:
        break;
    }
  };

  const valiFormInput = () => {
    let currentValidEmail = true;
    let currentValidBusiness = true;

    const isEmailValid = emailRegex.test(email);
    const isBusinessValid = Boolean(selectedBusiness?.id);

    if (!email) {
      currentValidEmail = false;
    } else {
      currentValidEmail = isEmailValid;
    }

    if (selectedBusiness?.id) {
      currentValidBusiness = isBusinessValid;
    }

    return currentValidEmail && currentValidBusiness;
  };

  const onInvite = () => {
    setsubmitted(true);
    const validForm = valiFormInput();

    if (validForm) {
      const input = {
        business_id: selectedBusiness?.id,
        email,
      };

      if (expirationDate) {
        input.expired_at = expirationDate.toISOString();
      }

      requestCreateBusinessInvitation(businessInviteDispatch, { input });
    }
  };

  return (
    <div className="max-w-4xl grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
      <div className="bg-white border border-gray-200 divide-y divide-gray-200 shadow-sm sm:overflow-hidden rounded-md sm:rounded-lg lg:col-start-1 lg:col-span-2">
        <div className="space-y-6 px-4 py-6 sm:p-6">
          {newBusinessInvite?.id && (
            <ModalConfirm
              open={showSuccessModal}
              setOpen={(open) => {
                setshowSuccessModal(open);
              }}
              title="Success"
              description="Successfully sent the business access invitation"
              type="SUCCESS"
              onConfirm={() => {
                navigate("/business-invites");
                clearBusinessInvitation(businessInviteDispatch);
              }}
            />
          )}
          {newBusinessInviteError && (
            <Alert
              title="Error"
              type="error"
              message={
                parsedErrorResponse?.message || "Error to invite business."
              }
              errors={newBusinessInviteError?.errors}
            />
          )}
          <div className="grid grid-cols-1 gap-4">
            {newBusinessInviteLoading ? (
              <InputSkeleton rows={3} />
            ) : (
              <div className="col-span-6 sm:col-span-3 space-y-6">
                <div>
                  <FormLabel
                    htmlFor="businessID"
                    label={t("Business Name")}
                    required
                  />
                  <ReactSelect
                    classNamePrefix="select2-selection"
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor: !businessError ? "#D1D5DB" : "red",
                      }),
                      border: "1px solid red",
                      menu: (provided) => ({
                        ...provided,
                        fontSize: "14px",
                      }),
                      option: (provided) => ({
                        ...provided,
                        fontSize: "14px",
                        lineHeight: "20px",
                      }),
                    }}
                    options={businesses}
                    placeholder={
                      businesses.length === 0
                        ? t("No Business Profile Yet")
                        : t("Select Business Name")
                    }
                    isLoading={businessLoading}
                    isDisabled={businessLoading}
                    value={selectedBusiness}
                    onChange={setselectedBusiness}
                    menuPortalTarget={document.body}
                  />
                  {businessError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(businessError)}
                    </div>
                  )}
                </div>
                <div>
                  <FormLabel
                    htmlFor="email"
                    label={t("Recipient Email")}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    placeholder={t("Enter Recipient Email")}
                    onChange={(e) => setemail(e.target.value)}
                    className={classNames(
                      emailError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                      "mt-1 block w-full text-sm rounded-md shadow-sm"
                    )}
                  />
                  {emailError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(emailError)}
                    </div>
                  )}
                </div>
                <div>
                  <FormLabel
                    htmlFor="expirationDate"
                    label={t("Expiration Date")}
                  />
                  <ReactDatePicker
                    name="expirationDate"
                    className={classNames(
                      newExpirationDateError
                        ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                      "mt-1 block w-full text-sm rounded-md shadow-sm"
                    )}
                    selected={expirationDate}
                    onChange={setexpirationDate}
                    minDate={minDate}
                    maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                    placeholderText={t("Select Date")}
                    dateFormat="dd/MM/yyyy"
                  />
                  {newExpirationDateError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(newExpirationDateError)}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="bg-gray-50 rounded-b-md sm:rounded-b-lg px-4 py-6 text-right sm:px-6">
          <Button
            className="w-full sm:w-auto"
            loading={newBusinessInviteLoading}
            disabled={newBusinessInviteLoading}
            title={t("Invite")}
            onClick={() => onInvite()}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessInvitationCreate;
